export default "__VITE_ASSET__BZrngrhy__"